import { InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

function SearchBar({
  placeholder = "Search",
  size = "small",
  keyword,
  setKeyword,
}) {
  return (
    <TextField
      fullWidth
      autoComplete={false}
      placeholder={placeholder}
      value={keyword}
      onChange={(e) => setKeyword(e.target.value)}
      size={size}
      height="55px"
      InputProps={{
        style: {
          borderRadius: "30px",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
          marginBottom: 2,
        },
        endAdornment: (
          <InputAdornment position="end">
            <SearchIcon fontSize="small" />
          </InputAdornment>
        ),
      }}
    />
  );
}

export default SearchBar;
